import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaCertificate,
    FaBalanceScale,
    FaClipboardCheck,
    FaShieldAlt
} from "react-icons/fa";

const CertificationsCompliance = () => {
    return (
        <section className="section certification-section">
            <Container>

                {/* Section Heading */}
                <div className="section-title fade-up">
                    <h2>Certifications & Compliance</h2>
                    <p>
                        Our commitment to quality, safety, and regulatory compliance
                        ensures trust at every level of our operations.
                    </p>
                </div>

                <Row className="align-items-center">

                    {/* LEFT – CERTIFICATION BADGES */}
                    <Col lg={6} className="mb-4 fade-up">
                        <div className="certification-box">

                            <div className="cert-badge">
                                <FaCertificate />
                                <h5>ISO Certified</h5>
                                <p>
                                    Manufacturing and quality management systems aligned
                                    with recognized ISO standards.
                                </p>
                            </div>

                            <div className="cert-badge">
                                <FaClipboardCheck />
                                <h5>Quality Management System</h5>
                                <p>
                                    Batch-wise testing, documentation, and traceability
                                    ensure consistent product performance.
                                </p>
                            </div>

                        </div>
                    </Col>
                    <Col lg={6} className="mb-4 fade-up">
                        <div className="certification-box">

                            <div className="cert-badge">
                                <FaBalanceScale />
                                <div>
                                    <h5>Regulatory Compliance</h5>
                                    <p>
                                        All products and processes comply with applicable
                                        agricultural and industrial regulations.
                                    </p>
                                </div>
                            </div>

                            <div className="cert-badge">
                                <FaShieldAlt />
                                <div>
                                    <h5>Ethical & Transparent Practices</h5>
                                    <p>
                                        Honest business operations, proper approvals, and
                                        responsible marketing practices.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </Col>
                </Row>

            </Container>
        </section>
    );
};

export default CertificationsCompliance;
